import { render, staticRenderFns } from "./CardStore.vue?vue&type=template&id=22ffd711"
import script from "./CardStore.vue?vue&type=script&lang=js"
export * from "./CardStore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports